/* eslint-disable */
/**
 * This file was generated by Itecho.TSGen tool
 * Version and info generated in .version
 * Any changes to this file will be lost if regenerated 
 */

import { webRequest, fileRequest } from "../request";
import type BlockAnomaly from "../interfaces/blockAnomaly";
import type BlockRowDisplay from "../interfaces/blockRowDisplay";
import type BlockStateRequest from "../interfaces/blockStateRequest";
import type DashboardFarmDisplay from "../interfaces/dashboardFarmDisplay";
import type DashboardLandDisplay from "../interfaces/dashboardLandDisplay";
import type FarmAnomalyRequest from "../interfaces/farmAnomalyRequest";
import type FarmDisplay from "../interfaces/farmDisplay";
import type FarmLandGeojson from "../interfaces/farmLandGeojson";
import type IdRequest from "../interfaces/idRequest";
import type LandBoundaryCoordinates from "../interfaces/landBoundaryCoordinates";
import type LocationDataGrouped from "../interfaces/locationDataGrouped";
import type LocationSeasonRequest from "../interfaces/locationSeasonRequest";
import type PaginationRequestCustomFarm from "../interfaces/paginationRequestCustomFarm";
import type PaginationRequestSearch from "../interfaces/paginationRequestSearch";
import type PaginationResponse from "../interfaces/paginationResponse";
import type SaveBlockRequest from "../interfaces/saveBlockRequest";

export default {
    paged: (request: PaginationRequestSearch) => webRequest<PaginationResponse<FarmDisplay>>('/api/farm/paged', {
        method: 'post',
        body: request
    }),
    update: (farm: FarmDisplay) => webRequest<unknown>('/api/farm/update', {
        method: 'post',
        body: farm
    }),
    landsPaged: (request: PaginationRequestCustomFarm) => webRequest<PaginationResponse<DashboardLandDisplay>>('/api/farm/landspaged', {
        method: 'post',
        body: request
    }),
    blocksForEdit: (request: PaginationRequestCustomFarm) => webRequest<PaginationResponse<BlockRowDisplay>>('/api/farm/blocksforedit', {
        method: 'post',
        body: request
    }),
    processFarm: (request: IdRequest) => webRequest<unknown>('/api/farm/processfarm', {
        method: 'post',
        body: request
    }),
    runYieldCron: () => webRequest<unknown>('/api/farm/runyieldcron'),
    sync: (request: IdRequest) => webRequest<unknown>('/api/farm/sync', {
        method: 'post',
        body: request
    }),
    removePoints: (request: IdRequest) => webRequest<unknown>('/api/farm/removepoints', {
        method: 'post',
        body: request
    }),
    createTiff: (request: IdRequest) => webRequest<unknown>('/api/farm/createtiff', {
        method: 'post',
        body: request
    }),
    locationData: (request: LocationSeasonRequest) => webRequest<LocationDataGrouped[]>('/api/farm/locationdata', {
        method: 'post',
        body: request
    }),
    saveBlock: (request: SaveBlockRequest) => webRequest<unknown>('/api/farm/saveblock', {
        method: 'post',
        body: request
    }),
    setBlockApproval: (request: BlockStateRequest) => webRequest<unknown>('/api/farm/setblockapproval', {
        method: 'post',
        body: request
    }),
    setBlockReady: (request: BlockStateRequest) => webRequest<unknown>('/api/farm/setblockready', {
        method: 'post',
        body: request
    }),
    checkFarmAnomalies: (request: FarmAnomalyRequest, ct: unknown) => webRequest<BlockAnomaly[]>('/api/farm/checkfarmanomalies', {
        method: 'post',
        body: request,
        queryParams: {
            ct
        }
    }),
    downloadLocationDataGroupedDay: (request: LocationSeasonRequest) => fileRequest('/api/farm/downloadlocationdatagroupedday', {
        queryParams: {
            ...request
        }
    }),
    downloadLocationData: (request: LocationSeasonRequest) => fileRequest('/api/farm/downloadlocationdata', {
        queryParams: {
            ...request
        }
    }),
    available: (request: PaginationRequestSearch) => webRequest<PaginationResponse<DashboardFarmDisplay>>('/api/farm/available', {
        method: 'post',
        body: request
    }),
    landBoundary: (id: number) => webRequest<LandBoundaryCoordinates[]>('/api/farm/landboundary', {
        queryParams: {
            id
        }
    }),
    geoJson: (id: number) => webRequest<FarmLandGeojson>('/api/farm/geojson', {
        queryParams: {
            id
        }
    })
}